// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3pf7u","productName":"Table_productName__1nfwG"};